import { useState, useEffect } from "react"

type LayoutMode = "sidebar" | "dock"

export function useLayoutSettings() {
  const [mode, setMode] = useState<LayoutMode>(() => {
    const saved = localStorage.getItem("layout-mode")
    return (saved as LayoutMode) || "dock"
  })

  useEffect(() => {
    localStorage.setItem("layout-mode", mode)
  }, [mode])

  return { mode, setMode }
}
